<template>
	<modal class="evidence-modal" size="medium" @close="close">
		<div slot="header">
			<h3>
				<b>Evidence</b>
			</h3>
		</div>
		<div slot="body">
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label><b>Evidence URL</b></label>
						<input
							type="text"
							name="evidence_url"
							class="input form-control"
							:class="{ 'is-invalid': !isValid }"
							v-model="formEvidenceUrl"
							@input="validateUrl"
						/>
						<small v-if="!isValid" class="text-danger">URL tidak valid</small>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<button class="btn btn-light" @click="close">
				Cancel
			</button>
			<button
				class="btn btn-primary"
				:class="{ 'is-loading': isUpdating }"
				:disabled="!isValid"
				@click="update"
			>
				<span>Update</span>
			</button>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { duplicateVar, isUrlValid } from '@/lib/helper';

export default {
	components: {
		Modal,
	},
	props: {
		evidenceUrl: {
			type: String,
			default: '',
		},
		isUpdating: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			formEvidenceUrl: '',
			isValid: true,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		selectFile(event) {
			const target = event.target;
			const files = target.files;
			this.file = files[0];
		},
		validateUrl() {
			this.isValid = isUrlValid(this.formEvidenceUrl);
		},
		update() {
			this.validateUrl();
			if (!this.isValid) {
				return;
			}
			this.$emit('update', this.formEvidenceUrl);
		},
	},
	mounted() {
		this.formEvidenceUrl = duplicateVar(this.evidenceUrl);
	},
};
</script>
